import styled from "styled-components";

export const RegulatoryCompanyShell = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-6, 0.6rem);
  width: 100%;
  min-width: 0;
`;

export const RegulatoryCompanyItem = styled.li`
  position: relative;
  padding-left: 0.7rem;
  list-style: none;
  width: 100%;
  min-width: 0;
  word-break: break-word;
  overflow-wrap: anywhere;
`;

export const RegulatoryCompanyItemText = styled.span`
  &::before {
    position: absolute;
    left: 0rem;
    top: 0;
    display: block;
    content: "•";
    color: #2a2f37;
    font-size: 1.4rem;
  }
`;

export const RegulatoryCompanyNumber = styled.div``;

export const TooltipWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  margin-top: 0.2rem;
  z-index: 100;
  border-radius: var(--Border-Radius-4, 0.4rem);
  border: 1px solid var(--Color-Common-Border-Secondary, #b1b8c4);
  background: var(--Color-Common-Bg-Primary, #fff);
  box-shadow: 0px 4px 8px 0px rgba(0, 0, 0, 0.16),
    0px 0px 4px 0px rgba(0, 0, 0, 0.12);
  display: none;

  .tooltip {
    color: var(--Color-Common-Text-Primary, #2a2f37);
    font-size: 1.2rem;
    font-weight: 400;
    white-space: normal;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    display: flex;
    width: 100%;
    padding: var(--Spacing-12, 1.2rem) var(--Spacing-8, 0.8rem);
    gap: var(--Spacing-6, 0.6rem);
    border: none;
  }
`;
